import React from 'react';
import styles from './Container.module.css';

export const Container = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...rest }, ref) => (
  <div
    ref={ref}
    className={[styles.root, className].filter(Boolean).join(' ')}
    {...rest}
  />
));

Container.displayName = 'Container';

export const ContainerLG = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...rest }, ref) => (
  <div
    ref={ref}
    className={[styles.rootLg, className].filter(Boolean).join(' ')}
    {...rest}
  />
));

ContainerLG.displayName = 'ContainerLG';
